import type { Party } from "@/mocks/partes";
import PartyStatusBadge from "./PartyStatusBadge";
import PartyTypeBadge from "./PartyTypeBadge";

interface PartiesTableProps {
  parties: Party[];
  onView: (party: Party) => void;
  onEdit?: (party: Party) => void;
  onLink?: (party: Party) => void;
}

export default function PartiesTable({ parties, onView, onEdit, onLink }: PartiesTableProps) {
  return (
    <div className="overflow-x-auto bg-white rounded-xl border border-background-200/70">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200 bg-background-50/50">
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Nome / Razão social</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Tipo</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Papel principal</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden lg:table-cell">CPF/CNPJ</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden md:table-cell">Município/UF</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden xl:table-cell">E-mail</th>
            <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Vínculos</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Status</th>
            <th className="text-right px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody>
          {parties.map((party) => (
            <tr key={party.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="px-4 py-3">
                <div>
                  <p className="text-sm font-medium text-foreground-900">{party.name}</p>
                  <p className="text-xs text-foreground-400">{party.institution !== "—" ? party.institution : ""}</p>
                </div>
              </td>
              <td className="px-4 py-3"><PartyTypeBadge type={party.type} /></td>
              <td className="px-4 py-3">
                <span className="text-xs text-foreground-600">{party.primaryRole}</span>
              </td>
              <td className="px-4 py-3 text-xs text-foreground-500 hidden lg:table-cell">{party.documentId}</td>
              <td className="px-4 py-3 text-xs text-foreground-500 hidden md:table-cell">{party.municipality}/{party.uf}</td>
              <td className="px-4 py-3 text-xs text-foreground-500 hidden xl:table-cell truncate max-w-[200px]">{party.email}</td>
              <td className="px-4 py-3 text-center">
                <span className={`text-xs font-semibold ${party.activeLinks > 0 ? "text-primary-600" : "text-foreground-400"}`}>
                  {party.activeLinks}
                </span>
              </td>
              <td className="px-4 py-3"><PartyStatusBadge status={party.status} /></td>
              <td className="px-4 py-3">
                <div className="flex items-center justify-end gap-1">
                  <button onClick={() => onView(party)} className="w-8 h-8 rounded-lg flex items-center justify-center text-foreground-400 hover:text-primary-600 hover:bg-primary-50 transition-colors" title="Visualizar">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                  </button>
                  {onEdit && (
                    <button onClick={() => onEdit(party)} className="w-8 h-8 rounded-lg flex items-center justify-center text-foreground-400 hover:text-accent-600 hover:bg-accent-50 transition-colors" title="Editar">
                      <i className="ri-edit-line w-4 h-4 flex items-center justify-center" />
                    </button>
                  )}
                  {onLink && (
                    <button onClick={() => onLink(party)} className="w-8 h-8 rounded-lg flex items-center justify-center text-foreground-400 hover:text-secondary-600 hover:bg-secondary-50 transition-colors" title="Criar vínculo">
                      <i className="ri-link-m w-4 h-4 flex items-center justify-center" />
                    </button>
                  )}
                  <button className="w-8 h-8 rounded-lg flex items-center justify-center text-foreground-400 hover:text-foreground-600 hover:bg-background-100 transition-colors" title="Mais ações">
                    <i className="ri-more-2-fill w-4 h-4 flex items-center justify-center" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}